// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-wrapper[data-v-3a56f454] {\n  max-height: calc(100vh - 200px) !important;\n}", ""]);
// Exports
module.exports = exports;
